import { IAuthToken } from '../utils/constants/interfaces';

/* actions */
export enum ActionType {
  SetUserAuthToken = 'user/set-auth-token',
  SetUserLoggedOut = 'user/set-user-logged-out',
  SetUserLastApiActivity = 'user/set-last-api-activity',
  SetUser = 'user/set-user',
  SetIsLoading = 'settings/set-is-loading',
  SetDevSetupRequired = 'settings/set-dev-setup-required',
  SetApplicationVersion = 'setting/set-application-version',
  SetApplicationReady = 'setting/set-application-ready',
  SetApiReady = 'settings/set-api-ready'
}

export interface IUserState extends IAuthToken {
  lastApiActivity: Date | null;
}

export interface IAppSettings {
  isLoading: boolean;
  devSetupRequired: boolean;
  apiReady: boolean;
  applicationReady: boolean;
  applicationVersion: string;
}

export interface IStoreState {
  user: IUserState;
  settings: IAppSettings;
}

export interface IAppContext {
  state: IStoreState;
  dispatch: React.Dispatch<Actions>;
}

export interface ISetUser {
  type: ActionType.SetUser;
  payload: IUserState;
}

export interface ISetUserAuthToken {
  type: ActionType.SetUserAuthToken;
  payload: IAuthToken;
}

export interface ISetUserLoggedOut {
  type: ActionType.SetUserLoggedOut;
}

export interface ISetUserLastApiActivity {
  type: ActionType.SetUserLastApiActivity;
  payload: Date;
}

export interface ISetIsLoading {
  type: ActionType.SetIsLoading;
  payload: boolean;
}

export interface ISetDevSetupRequired {
  type: ActionType.SetDevSetupRequired;
  payload: boolean;
}

export interface ISetApplicationVersion {
  type: ActionType.SetApplicationVersion;
  payload: string;
}

export interface ISetApplicationReady {
  type: ActionType.SetApplicationReady;
  payload: boolean;
}
export interface ISetApiReady {
  type: ActionType.SetApiReady;
  payload: boolean;
}

export type Actions =
  | ISetUserAuthToken
  | ISetUserLoggedOut
  | ISetUser
  | ISetUserLastApiActivity
  | ISetIsLoading
  | ISetDevSetupRequired
  | ISetApplicationVersion
  | ISetApplicationReady
  | ISetApiReady;
